import ShortcutPopup from '@picsart/rc/old/ShortcutPopup';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isShortcutsPopupOpen, toggleShortcutsPopup } from 'modules/shortcutsPopup';
import { IShortcutPopup } from '@picsart/rc/types/containerComponents/ShortcutPopup/types';

const shortcutCategories: IShortcutPopup['shortcutCategories'] = {
  general: 'general',
  video: 'video'
};

const shortcuts: IShortcutPopup['shortcuts'] = {
  copy: 'copy',
  past: 'past',
  cut: 'cut',
  delete: 'delete',
  move: 'move',
  moveBiggerSteps: 'moveBiggerSteps',
  deselect: 'deselect',
  play: 'play',
  pause: 'pause',
  undo: 'undo',
  redo: 'redo'
};

export const ShortcutsPopup = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isShortcutsPopupOpen);
  const togglePopupHandler = useCallback((state?: boolean) => {
    dispatch(toggleShortcutsPopup(state));
  }, []);

  return (
    isOpen && (
      <ShortcutPopup
        shortcutCategories={shortcutCategories}
        shortcuts={shortcuts}
        closeModal={() => togglePopupHandler(false)}
      />
    )
  );
};
